import React, { Component } from "react";
import autoSuggest from "../../../../lib/autoSuggestV2";
import cf from "../../../../lib/utils/common";
import recentSearch from "../../../../lib/getRecentSearchActivity";
import { getStorage, setStorage } from "../../../../lib/utils/localStorage";
import {
  invalidAlphanumeric,
  leadingSpaces,
} from "../../../../lib/utils/regex_cheat_sheet";
import { destinations } from '../../../../lib/destinations';

import { is } from "date-fns/locale";
import { title } from "process";

// static 5 cities
// const popularCitiess = [
//   {
//     title: "Mumbai",
//     destination_id: "11663",
//     city: "Mumbai",
//     destination_type: 1,
//   },
//   {
//     title: "New Delhi",
//     destination_id: "11667",
//     city: "New Delhi",
//     destination_type: 1,
//   },
//   {
//     title: "Chennai",
//     destination_id: "11634",
//     city: "Chennai",
//     destination_type: 1,
//   },
//   {
//     title: "Dubai",
//     destination_id: "12633",
//     city: "Dubai",
//     destination_type: 1,
//   },
//   {
//     title: "Paris",
//     destination_id: "10516",
//     city: "Paris",
//     destination_type: 1,
//   },
// ];

export default class Theme12 extends Component {
  constructor(props) {
    super(props);
    // console.log(this.props?.seoDataQuery, "seoDataQuery");
    this.searchBoxRef = React.createRef();
    this.advanceSearchWrapper = React.createRef();
    this.guestDetailWrapper = React.createRef();
    this.state = {
      activityName: this.props.isSrp
        ? new URLSearchParams(window.location.search).has("location")
          ? new URLSearchParams(window.location.search)
            .get("location")
            .toString()
          : this.props?.seoDataQuery?.title ? this.props?.seoDataQuery?.title : ""
        : "",
      isAutoSuggestVisible: false,
      popularCities: [],
      autoSuggestCityData: [],
      selectedAutoSuggestData: {
        title: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("location")
            ? new URLSearchParams(window.location.search)
              .get("location")
              .toString()
            : this.props?.seoDataQuery?.title ? this.props?.seoDataQuery?.title?.split("-")?.join(" ") : ""
          : "",
        city: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("location")
            ? new URLSearchParams(window.location.search)
              .get("location")
              .toString()
            : this.props?.seoDataQuery?.title ? this.props?.seoDataQuery?.title?.split("-")?.join(" ") : ""
          : "",
        destination_type: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("destination_type")
            ? new URLSearchParams(window.location.search).get("destination_type")
            : this.props?.seoDataQuery?.destination_type ? this.props?.seoDataQuery?.destination_type : ""
          : "",
        destination_id: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("destination_id")
            ? new URLSearchParams(window.location.search)
              .get("destination_id")
              .toString()
            : this.props?.seoDataQuery?.destination_id ? this.props?.seoDataQuery?.destination_id : ""
          : "",
      },
      lastArrowAction: "",
      selectedAutoSuggestIndex: -1,
      advSearch: false,
      isOneStar: false,
      isTwoStar: false,
      isThreeStar: false,
      isFourStar: false,
      isFiveStar: false,
      ratingSelected: [],
      guest_id: "",
      guestError: false,
      userProfileData: "",
      recentSearchData: JSON?.parse(localStorage?.getItem("recentSearchActivity") || "[]"),
      destinationDropdown: false,
      // getrecentSearchList:null,
      // getrecentSearchListLocal:null,
      // Calendar-related state removed
      search_key: "activitySearchKey",
      search_key_all: "activitySearchKeyAll",
      btnClicked: false,
    };
    this.wrapperRef = React.createRef();

  }
  clearRecentSearch = () => {
    localStorage.setItem('recentSearchActivity', JSON.stringify([]));
    this.setState({ recentSearchData: [] });
  }
  getDefaultCountries = async () => {
    try {
      const payload = {
        destination_id: "",
        site_id: this.props?.home?.data?.site?.id
      }
      const data = await destinations({ payload: payload, isSrp: this.props?.isSrp })
      // console.log(data, 'destination data')
      const cities = data?.data?.data?.map((el) => ({
        title: el?.name,
        destination_id: el?.destination_id,
        city: el?.name,
        destination_type: 3
      }))
      // console.log('cities:', cities);
      this.setState({
        popularCities: cities,
        autoSuggestCityData: cities
      })
    } catch (error) {
      console.error('Error in getDefaultCountries:', error);
    }
  }

  onChanegeSetActivityName = (value) => {
    let recentSearchArray = [];
    this.setState({ activityName: value, isError: "" });
    if (value.length < 3) {
      // Cancel any pending debounced API calls
      this.debouncedFetchData.cancel?.();

      this.setState({
        autoSuggestCityData: this.state.popularCities,
        selectedAutoSuggestData: { destination_id: "", destination_type: "", city: "" },
        recentSearchData: JSON?.parse(localStorage?.getItem("recentSearchActivity") || "[]"),
      });
      return;
    } else {
      this.debouncedFetchData(value, (data) => {
        // Check if the current input still has sufficient length
        if (this.state.activityName.length < 3) {
          return;
        }

        if (
          data &&
          data.data &&
          data.data.data
        ) {
          this.setState({
            autoSuggestCityData: [...data.data.data],
            isAutoSuggestVisible: true,
            recentSearchData: recentSearchArray,
          });
        } else {

          this.setState({
            autoSuggestCityData: [],
            isAutoSuggestVisible: true,
            recentSearchData: recentSearchArray,
          });
        }
      });
    }

  };

  // Store timeout at instance level for proper cancellation
  fetchTimeout = null;

  debouncedFetchData = (query, cb) => {
    // Clear any pending timeout
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }

    // Set new timeout
    this.fetchTimeout = setTimeout(() => {
      this.fetchData(query, cb);
    }, 400);
  };

  // Add cancel method to debouncedFetchData
  componentDidMount() {
    this.debouncedFetchData.cancel = () => {
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout);
        this.fetchTimeout = null;
      }
    };
    document.addEventListener("mousedown", this.handleClickOutside);

    // Call getDefaultCountries to load popular cities
    this.getDefaultCountries();
  }

  fetchData = async (query, callBackFunc) => {
    if (query != "") {
      const res = await autoSuggest({
        searchText: query,
        isSrp: this.props.isSrp,
      });
      callBackFunc(res);
    } else {
      callBackFunc(null);
    }
  };

  onClickSearchActivity = () => {
    // console.log(this.state.activityName, this.state.selectedAutoSuggestData.title, 'activityName')

    if ((this.state.activityName?.length > 0 && !(this.state.selectedAutoSuggestData && this.state.selectedAutoSuggestData.title))) {
      this.state.isAutoSuggestVisible = false
      this.setState({ isError: "NoMatch" });
      return;
    }
    if (this.props.isOffline === true && this.state.guest_id === "") {
      this.setState({ guestError: true });
      return;
    } else {
      this.setState({ guestError: false });
    }
    if (!this.state.activityName?.length == 0) {
      this.setState({ btnClicked: true })
    }

    let recentSearch_Localstorage = JSON?.parse(localStorage?.getItem("recentSearchActivity") || "[]");
    let recentSearchData = recentSearch_Localstorage?.filter((item) => item?.title !== this.state.selectedAutoSuggestData?.title);
    if (recentSearchData?.length > 4) {
      recentSearchData.pop();
    }
    if (this.state.selectedAutoSuggestData?.destination_id !== "") {
      localStorage.setItem("recentSearchActivity", JSON?.stringify([this.state.selectedAutoSuggestData, ...recentSearchData]));
      this.setState({ recentSearchData: [this.state.selectedAutoSuggestData, ...recentSearchData] })
    }
    // Calendar and date logic removed
    if (this.state.selectedAutoSuggestData.destination_type == 3) {
      let urlQuery = {
        // currency: localStorage.getItem("selectedCurrency")  || "INR",
        country_id: this.state.selectedAutoSuggestData.destination_id,
        destination_type: this.state.selectedAutoSuggestData.destination_type,
      };
      let SRPurlQuery = {
        location: this.state.selectedAutoSuggestData.title,
        destination_type: this.state.selectedAutoSuggestData.destination_type,
        destination_id: this.state.selectedAutoSuggestData.destination_id,
        pagetype: "city"
        // currency: localStorage.getItem("selectedCurrency") || "INR",
        // rating: [...new Set(this.state.ratingSelected)].join(","),
        // guestId: this.state.guest_id,
      };
      if (this.props.isOffline === true) {
        if (this.state.guest_id !== "") {
          const searchParams = new URLSearchParams(urlQuery);
          const queryString = searchParams.toString();
          window.location = "/offlinesearch/activity?" + queryString;
        }
      } else {
        if (this.state?.selectedAutoSuggestData?.country_to_category) {
          f.redirectTo("/activity/search", SRPurlQuery);
        } else {
          cf.redirectTo(`/activity/destination/${this.state?.selectedAutoSuggestData?.title?.split(" ")?.join("-")}`, urlQuery);
        }
      }
    } else if (this.state.selectedAutoSuggestData.destination_type == 2) {
      let urlQuery = {
        activity_code: this.state.selectedAutoSuggestData.destination_id,
        // currency: localStorage.getItem("selectedCurrency")  || "INR",
      };
      if (this.props.isOffline === true) {
        if (this.state.guest_id !== "") {
          const searchParams = new URLSearchParams(urlQuery);
          const queryString = searchParams.toString();
          window.location = "/offlinesearch/activity?" + queryString;
        }
      } else {
        cf.redirectTo("/activity/details", urlQuery);
      }
    } else if (this.state.selectedAutoSuggestData.destination_type == 1) {
      let urlQuery = {
        location: this.state.selectedAutoSuggestData.city,
        destination_type: this.state.selectedAutoSuggestData.destination_type,
        destination_id: this.state.selectedAutoSuggestData.destination_id,
        pagetype: "city"
        // currency: localStorage.getItem("selectedCurrency") || "INR",
        // rating: [...new Set(this.state.ratingSelected)].join(","),
        // guestId: this.state.guest_id,
      };
      if (this.props.isOffline === true) {
        if (this.state.guest_id !== "") {
          const searchParams = new URLSearchParams(urlQuery);
          const queryString = searchParams.toString();
          window.location = "/offlinesearch/activity?" + queryString;
        }
      } else {
        cf.redirectTo("/activity/search", urlQuery);
      }
    } else {
      this.state.isAutoSuggestVisible = false
      this.setState({ isError: "emptyString" });
      // cf.redirectTo("/activity/destination",);

    }
    setTimeout(() => {
      this.setState({ btnClicked: false })
    }, 2000);

  };
  onClickSetActivityName = (element) => {
    this.setState({
      activityName: element.title || element.city,
      selectedAutoSuggestData: element,
      isError: "",
    });
  };
  onInputFocus = (fieldName) => {
    if (fieldName == "autocomplete") {
      if (this.state.isAutoSuggestVisible === false) {
        this.setState({ isAutoSuggestVisible: true });
        this.setState({ isError: "" });

      }
    } else if (fieldName == "search") {
      this.setState({ isAutoSuggestVisible: false });

    }
  };

  keyPress = (action) => {
    switch (action) {
      case "ArrowDown":
        // console.log("keyPress fn down called ", action);
        let children = document.getElementById(
          "ACTIVITY-AUTO-SUGGEST-DATA-LIST"
        ).children;

        let selectIndex = 0;
        selectIndex =
          this.state.selectedAutoSuggestIndex == children.length - 1
            ? 0
            : this.state.selectedAutoSuggestIndex + 1;
        // console.log("children of auto-suggest", children);
        for (let index = 0; index < children.length; index++) {
          let childElement = children[index];
          let id = childElement.id;
          if (id != null && id != "") {
            childElement.style.backgroundColor =
              selectIndex === index ? "#ccc" : "#fff";
          }
        }
        this.setState({
          selectedAutoSuggestIndex: selectIndex,
          lastArrowAction: "ArrowDown",
        });
        break;
      case "ArrowUp":
        // console.log("keyPress fn up called ", action);
        let childrens = document.getElementById(
          "ACTIVITY-AUTO-SUGGEST-DATA-LIST"
        ).children;
        let selectIndexUp = 0;
        selectIndexUp =
          this.state.selectedAutoSuggestIndex == childrens.length - 1
            ? 0
            : this.state.selectedAutoSuggestIndex == -1
              ? 0
              : this.state.selectedAutoSuggestIndex - 1;
        // console.log("children of auto-suggest", childrens);
        for (let index = 0; index < childrens.length; index++) {
          let childElement = childrens[index];
          let id = childElement.id;
          if (id != null && id != "") {
            childElement.style.backgroundColor =
              selectIndexUp === index ? "#ccc" : "#fff";
          }
        }
        // this.setState((prevState) => ({
        //   selectedAutoSuggestIndex:
        //     prevState.selectedAutoSuggestIndex > 0
        //       ? prevState.lastArrowAction=="ArrowDown"?prevState.selectedAutoSuggestIndex - 1:prevState.selectedAutoSuggestIndex
        //       : prevState.selectedAutoSuggestIndex+1,
        //   lastArrowAction: "ArrowUp",
        // }));
        this.setState({
          selectedAutoSuggestIndex: selectIndexUp,
          lastArrowAction: "ArrowUp",
        });
        break;
      case "Enter":
      case "Tab":
        let indexToSelect = 0;
        if (
          this.state.selectedAutoSuggestIndex != 0 &&
          this.state.lastArrowAction == "ArrowUp"
        ) {
          indexToSelect = this.state.selectedAutoSuggestIndex;
        } else if (
          this.state.selectedAutoSuggestIndex != 0 &&
          this.state.lastArrowAction == "ArrowDown"
        ) {
          indexToSelect = this.state.selectedAutoSuggestIndex;
        }
        // const indexToSelect = this.state.selectedAutoSuggestIndex===0?0:this.state.lastArrowAction?"ArrowUp"?this.state.selectedAutoSuggestIndex+1:this.state.selectedAutoSuggestIndex-1:0;
        const selectedItem = this.state.autoSuggestCityData[indexToSelect - 1];
        this.setState({
          activityName: selectedItem.city,
          selectedAutoSuggestData: selectedItem,
          isError: "",
          isAutoSuggestVisible: false,
          selectedAutoSuggestIndex: indexToSelect,
          lastArrowAction: "",
        });
        break;

      default:
        console.log("default", action);
        break;
    }
  };

  scrollToMyRef = () => {
    this.searchBoxRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.searchBoxRef.current &&
      !this.searchBoxRef.current.contains(event.target)
    ) {
      this.setState({
        isAutoSuggestVisible: false,
        destinationDropdown: false,
      });
    }
  };


  // The below code is for avoiding the scroll of body when popup is open by adding class to body 

  componentDidUpdate(prevProps, prevState) {
    // Run only when destinationDropdown changes
    if (prevState.destinationDropdown !== this.state.destinationDropdown) {
      if (this.state.destinationDropdown) {
        document.body.classList.add("no-scroll");
        document.documentElement.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
        document.documentElement.classList.remove("no-scroll");
      }
      
      // Notify parent component about dropdown state change
      if (this.props.onDestinationDropdownChange) {
        this.props.onDestinationDropdownChange(this.state.destinationDropdown);
      }
    }

    // Update selectedAutoSuggestData when seoDataQuery prop changes
    if (this.props.isSrp && this.props.seoDataQuery && prevProps.seoDataQuery !== this.props.seoDataQuery) {
      const urlParams = new URLSearchParams(window.location.search);
      const hasUrlParams = urlParams.has("location") && urlParams.has("destination_id") && urlParams.has("destination_type");

      // Only update if URL params are not present (meaning we should use seoDataQuery)
      if (!hasUrlParams) {
        // console.log("Updating selectedAutoSuggestData with seoDataQuery:", this.props.seoDataQuery);
        this.setState({
          selectedAutoSuggestData: {
            title: this.props.seoDataQuery?.title || "",
            city: this.props.seoDataQuery?.title || "",
            destination_type: this.props.seoDataQuery?.destination_type || "",
            destination_id: this.props.seoDataQuery?.destination_id || "",
          },
          activityName: this.props.seoDataQuery?.title || "",
        });
      }
    }
  }




  render() {
    return (
      <>
        {this.props.isMobile ? (
          // mobile section starts

          <div className={
            // ["/", "/activities"].includes(window.location.pathname)
            this.props?.homePage == "homePage"
              ? ""
              : this?.props?.searchIconOnly
                ? this.props.cssfile.mobile_widget_parent_search_icon
                : this.props.cssfile.mobile_widget_parent
          }>
            <div
              className="container mx-auto  xl:px-8"
              ref={this.searchBoxRef}
              onClick={(e) => {
                e.stopPropagation();
                if (this.state.isAutoSuggestVisible) {
                  this.setState({
                    isAutoSuggestVisible: false,
                  });
                }
              }}
            >

              {
                !this?.props?.searchIconOnly &&
                (<div className={
                  // ["/", "/activities"].includes(window.location.pathname)
                  this.props?.homePage == "homePage"
                    ? this.props.cssfile.activity_way_title_homepage
                    : this.props.cssfile.activity_way_title}>
                  <h2 className={this.props.cssfile.activity_title}>{this?.props?.headingName || "Activities"}</h2>
                </div>)
              }
              <div className={
                this.props.isSrp
                  ? this.props.cssfile.srp_search_wid_container
                  : (
                    // ["/", "/activities"].includes(window.location.pathname)
                    this.props.homePage == "homePage"
                      ? this.props.cssfile.activity_search_wid_container
                      : this.props.cssfile.activity_search_wid_container_other)
              }>
                <div className={
                  // ["/", "/activities"].includes(window.location.pathname)
                  this.props.homePage == "homePage"
                    ? this.props.cssfile.activity_search_wid_main
                    : this.props.cssfile.activity_search_wid_main_other}>

                  <div
                    className={
                      this?.props?.searchIconOnly ? this.props.cssfile.activity_search_details_container_search_icon : this.props.cssfile.activity_search_details_container
                    }
                  >
                    <div
                      className={this?.props?.searchIconOnly ? this.props.cssfile.activity_search_details_main_search_icon :
                        (
                          // ["/", "/activities"].includes(window.location.pathname)
                          this.props.homePage == "homePage"
                            ? this.props.cssfile.activity_search_details_main_homepage
                            : this.props.cssfile.activity_search_details_main)
                      }
                    >
                      <div
                        className={this?.props?.searchIconOnly ? this.props.cssfile.activity_search_details_row_search_icon : this.props.cssfile.activity_search_details_row}
                      >
                        <div
                          className={
                            this.props.cssfile.activity_search_column +
                            " " +
                            this.props.cssfile.activity_search_name
                          }
                        >
                          <div
                            id="search-widget-main"
                            className={
                              this.props.cssfile.activity_search_wid_inputfield
                            }
                          >
                            <div
                              className={
                                this.props.cssfile
                                  .activity_search_wid_inputfield_main
                              }

                            // onClick={this.scrollToMyRef}
                            >
                              <input
                                type={this?.props?.searchIconOnly ? "hidden" : "text"}
                                readOnly
                                tabIndex={1}
                                placeholder={`Search by Destinations / Cities / Activities`}  //Search destinationsD
                                autoComplete={"off"}
                                id="myTextField"
                                className={
                                  this.props.cssfile.search_widget_input_new
                                }
                                value={
                                  !cf.isValueEmpty(this.state.activityName) &&
                                    !this.state.isAutoSuggestVisible
                                    ? this.state.activityName
                                    : ""
                                }
                                onClick={(e) => {
                                  this.scrollToMyRef();
                                  e.stopPropagation();
                                  this.setState((prevState) => {
                                    return {
                                      ...prevState,
                                      destinationDropdown: true,
                                      activityName: "",
                                      autoSuggestCityData: prevState.popularCities,
                                      isError: "",
                                    };
                                  });
                                }}
                              />

                              {/* {this.state.isAutoSuggestVisible === true ? ( */}
                              <>
                                {this.state.destinationDropdown && (
                                  <div
                                    // isPopup={this.state.destinationDropdown}
                                    modalCss={
                                      this.props.isSrp
                                        ? this.props.modalCss
                                        : this.props.popupcss
                                    }
                                  // closePopup={this.closeDestinationPopup}
                                  // showBtn={false}
                                  // heading={"Destination"}
                                  >
                                    <div className={this.props.cssfile.search_modal_overlay}
                                      onClick={() => this.setState({ destinationDropdown: false })}
                                    >
                                      <div
                                        className={
                                          this.props.cssfile
                                            .activity_autocomplete_value
                                        }
                                        id="ACTIVITY-AUTO-SUGGEST-DATA-LIST"
                                      >
                                        <div
                                          className={
                                            this.props.cssfile
                                              .input_search_destination
                                          }
                                        >
                                          <img src="/images/search-grey.svg" alt="searchicon" />
                                          <input
                                            type="text"
                                            tabIndex={1}
                                            autoFocus
                                            autoComplete={"off"}
                                            id="myTextField"
                                            placeholder={`Search Destination`}
                                            maxLength={24}
                                            className={
                                              this.props.cssfile
                                                .search_widget_input_new
                                            }
                                            value={
                                              !cf.isValueEmpty(
                                                this.state.activityName
                                              )
                                                ? this.state.activityName
                                                : ""
                                            }
                                            onChange={(event) => {
                                              event.stopPropagation();
                                              this.onChanegeSetActivityName(
                                                event.target.value
                                              );
                                            }}
                                            onClick={(e) => {
                                              this.scrollToMyRef();
                                              e.stopPropagation();
                                              this.setState((prevState) => {
                                                return {
                                                  ...prevState,
                                                  isAutoSuggestVisible: true,
                                                  isError: "",
                                                  activityName: "",
                                                };
                                              });
                                            }}
                                            onKeyDown={(e) => {
                                              e.stopPropagation();
                                              this.keyPress(e.key);
                                            }}
                                          />
                                        </div>
                                        {this.state.recentSearchData.length > 0 && (
                                          <>
                                            <div className={this.props.cssfile.recent_search_header}>
                                              <div
                                                className={
                                                  this.props.cssfile
                                                    .activity_suggestionLblrecent
                                                }
                                              >
                                                Recent Searches
                                              </div>
                                              <button
                                                className={
                                                  this.props.cssfile
                                                    .clearbtn
                                                }

                                                onClick={() => this.clearRecentSearch()}
                                              >Clear</button>
                                            </div>
                                            {this.state.recentSearchData.map(
                                              (ele) => {
                                                if (!ele.title || !ele.city) {
                                                  return;
                                                }
                                                return (
                                                  <div
                                                    className={
                                                      this.props.cssfile
                                                        .activity_autocomplete_element
                                                    }
                                                  >

                                                    <div className={this.props.cssfile.activity_autocomplete_location_wrap}>
                                                      <div
                                                        className={
                                                          this.props.cssfile
                                                            .activity_autocompIcon
                                                        }
                                                      >
                                                        <img src={`/images/${ele?.destination_type == 2 ? "experiences_city.svg" : "location-grey.svg"}`} alt="locationicon" />
                                                      </div>
                                                      <div
                                                        className={
                                                          this.props.cssfile
                                                            .activity_autocomplete_name
                                                        }
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          this.setState({
                                                            activityName:
                                                              ele?.city,
                                                            isAutoSuggestVisible:
                                                              false,
                                                            destinationDropdown:
                                                              false,
                                                          });
                                                          this.onClickSetActivityName(
                                                            ele
                                                          );
                                                        }}
                                                      >
                                                        {ele?.title || ele?.city}
                                                      </div>
                                                      {/* <div className={this.props.cssfile.activity_autonwLabel}>United Arab Emirates</div> */}
                                                    </div>
                                                    <div
                                                      className={
                                                        this.props.cssfile
                                                          .activity_autocompIcon_arrow
                                                      }
                                                    >
                                                      <img src="/images/arrow-right-golden.svg" alt="locationicon" />
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </>
                                        )}
                                        {!cf.isValueEmpty(this.state.autoSuggestCityData) &&
                                          this.state.autoSuggestCityData.length > 0 ? (
                                          <>
                                            {/* SEARCH BY LABEL */}
                                            {this.state.autoSuggestCityData.length > 0 ? <div
                                              className={
                                                this.props.cssfile
                                                  .activity_suggestionLbl
                                              }
                                            >
                                              Popular Searches
                                            </div> : null}

                                            {/* LIST */}
                                            {this.state.autoSuggestCityData.map((element, index) => {
                                              return (
                                                <div
                                                  key={`city-${index}`}
                                                  className={
                                                    this.props.cssfile.activity_autocomplete_element
                                                  }
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.setState(
                                                      {
                                                        activityName: element.city,
                                                        isAutoSuggestVisible: false,
                                                        destinationDropdown: false,
                                                      },
                                                      async () => {
                                                        await this.onClickSetActivityName(element);
                                                        if (this?.props?.searchIconOnly) {
                                                          this.onClickSearchActivity();
                                                        }
                                                      }
                                                    );
                                                  }}
                                                >
                                                  <div className={this.props.cssfile.activity_autocomplete_location_flex}>
                                                    <div className={this.props.cssfile.activity_autocomplete_name}>
                                                      {element.title || element.city}
                                                    </div>

                                                    <div className={this.props.cssfile.activity_autocompIcon}>
                                                      <img
                                                        src={`/images/${element?.destination_type == 2
                                                          ? "experiences_city.svg"
                                                          : "location-grey.svg"
                                                          }`}
                                                        alt="locationicon"
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className={this.props.cssfile.activity_autocompIcon_arrow}>
                                                    <img
                                                      src="/images/arrow-right-golden.svg"
                                                      alt="arrow"
                                                    />
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </>
                                        ) : (
                                          /* EMPTY STATE */
                                          <div className={this.props.cssfile.empty_state} key="noresults">
                                            <div className={this.props.cssfile.empty_state__icon}>
                                              <img src="/images/search_noresult.svg" alt="No Result" />
                                            </div>
                                            <p className={this.props.cssfile.empty_state__text}>
                                              Oops! no results found.
                                            </p>
                                            <p className={this.props.cssfile.empty_state__subtext}>
                                              We didn’t find anything. Try adjusting your search
                                            </p>
                                          </div>
                                        )}



                                      </div>


                                    </div>
                                  </div>
                                )}
                              </>

                              {/* // ) : null} */}
                            </div>
                          </div>
                        </div>

                        {/* <div
                    className={`${this.props.cssfile.activity_search_details_row} ${this.props.cssfile.activity_nw}`}
                  > */}
                        {/* {console.log(this?.props?.searchIconOnly, this.props.cssfile.activity_search_widget_btn, "searchIconOnly1")} */}
                        <div className={this?.props?.searchIconOnly ? this.props.cssfile.activity_search_class_search_icon : this.props.cssfile.activity_search_class}>
                          {/* yes */}
                          <button
                            tabIndex={3}
                            // className={
                            //   this.props.cssfile.activity_search_widget_btn
                            // }
                            className={
                              this.state?.btnClicked
                                ? (this?.props?.searchIconOnly ? this.props.cssfile.activity_search_icon_btn
                                  : `${this.props.cssfile.activity_search_widget_btn} loading`)
                                : this.props.cssfile.activity_search_widget_btn
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              this?.props?.searchIconOnly ?
                                (this.setState((prevState) => {
                                  return {
                                    ...prevState,
                                    destinationDropdown: true,
                                    activityName: "",
                                    autoSuggestCityData: prevState.popularCities,
                                  };
                                }))
                                : this.onClickSearchActivity();
                            }}
                          >
                            <img className={this?.props?.searchIconOnly ? this.props.cssfile.activity_search_icon : this.props.cssfile.activity_search_widget_icon} src="/images/search-golden.svg" alt="search" />
                          </button>
                        </div>


                        {/*---------- below code is olny for home page and activity ---------------------------------- */}
                        {
                          (window.location.pathname === "/" || window.location.pathname === "/activities"
                            // || this.props.SerachWidMob == "activity"
                            // this.props.homePage=="homePage"
                          ) && (
                            // console.log(this?.props?.searchIconOnly, "searchIconOnly2"),
                            <div className={this.props.cssfile.activity_search_class_mobile}>
                              {/* no */}
                              <button
                                tabIndex={3}
                                // className={
                                //   this.props.cssfile.activity_search_widget_btn
                                // }
                                className={
                                  this.state?.btnClicked
                                    ? (this?.props?.searchIconOnly ? this.props.cssfile.activity_search_icon_btn
                                      : `${this.props.cssfile.activity_search_widget_btn} loading`)
                                    :
                                    this.props.cssfile.activity_search_widget_btn
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this?.props?.searchIconOnly ?
                                    (this.setState((prevState) => {
                                      return {
                                        ...prevState,
                                        destinationDropdown: true,
                                        activityName: "",
                                        autoSuggestCityData: prevState.popularCities,
                                      };
                                    }))
                                    : this.onClickSearchActivity();
                                }}
                              >
                                Search
                              </button>
                            </div>
                          )}



                        {/* ------------------------------------------------------------------------------ */}
                        {/* </div> */}
                        {this.state?.isError == "emptyString" ? <div className={this.props.cssfile.error_message}>Please enter a destination, city or activity</div> : this.state?.isError == "NoMatch" ? <div className={this.props.cssfile.error_message}>Please enter a valid destination</div> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // mobile section ends

          // desktop section starts
          <div
            className={this.props.isSrp ? (this.props.pagetype ? `${this.props.cssfile.srp_search} ${this.props.cssfile.city_search}` : this.props.cssfile.srp_search) : ""}
          >
            <div className={(window.location.pathname === "/" || window.location.pathname === "/activities" || window.location.pathname === "/hotels" ? this.props.cssfile.widget_parent_homepage : this.props.cssfile.widget_parent)}>
              <div className={(window.location.pathname === "/" || window.location.pathname === "/activities" || window.location.pathname === "/hotels" ? this.props.cssfile.widget_container_homepage : this.props.cssfile.widget_container)}>
                <div
                  className={this.props.cssfile.activity_search_box}
                  ref={this.searchBoxRef}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (this.state.isAutoSuggestVisible) {
                      this.setState({
                        isAutoSuggestVisible: false,
                      });
                    }
                  }}
                >
                  <div className={window.location.pathname === "/" || window.location.pathname === "/activities" || window.location.pathname === "/hotels" ? this.props.cssfile.activity_way_title_homepage : this.props.cssfile.activity_way_title}>
                    <h2 className={this.props.cssfile.activity_title}>{this?.props?.headingName || "Activities"}</h2>
                  </div>
                  <div
                    className={
                      this.props.isSrp
                        ? this.props.cssfile.srp_search_wid_container
                        : (["/", "/activities", "/hotels"].includes(window.location.pathname)
                          ? this.props.cssfile.activity_search_wid_container
                          : this.props.cssfile.activity_search_wid_container_other)
                    }
                  >
                    <div className={
                      ["/", "/activities", "/hotels"].includes(window.location.pathname)
                        ? this.props.cssfile.activity_search_wid_main
                        : this.props.cssfile.activity_search_wid_main_other
                    }>

                      <div
                        className={
                          this.props.isSrp
                            ? this.props.cssfile.srp_search_details_container
                            : this.props.cssfile.activity_search_details_container
                        }
                      >
                        <div
                          className={
                            this.props.cssfile.activity_search_details_main
                          }
                        >
                          <div
                            className={
                              this.props.cssfile.activity_search_details_row
                            }
                          >
                            <div
                              className={
                                this.props.cssfile.activity_search_column +
                                " " +
                                this.props.cssfile.activity_search_name
                              }
                            >
                              <div
                                id="search-widget-main"
                                className={
                                  this.props.cssfile.activity_search_wid_inputfield
                                }
                              >
                                <div
                                  className={
                                    this.props.cssfile
                                      .activity_search_wid_inputfield_main
                                  }

                                // onClick={this.scrollToMyRef}
                                >
                                  <img src="/images/location-grey.svg" className={this.props.cssfile.location_img} alt="location icon" />
                                  <input
                                    type="text"
                                    readOnly
                                    tabIndex={1}
                                    placeholder={`Search by Destinations / Cities / Activities`}
                                    autoComplete={"off"}
                                    id="myTextField"
                                    className={this.props.cssfile.search_input}
                                    value={
                                      !cf.isValueEmpty(this.state.activityName) &&
                                        !this.state.isAutoSuggestVisible
                                        ? this.state.activityName
                                        : ""
                                    }
                                    onClick={(e) => {
                                      this.scrollToMyRef();
                                      e.stopPropagation();
                                      this.setState((prevState) => {
                                        return {
                                          ...prevState,
                                          isAutoSuggestVisible:
                                            !prevState.isAutoSuggestVisible,
                                          activityName: "",
                                          autoSuggestCityData: prevState.popularCities,
                                          isError: "",
                                        };
                                      });
                                    }}
                                  />
                                  {this.state.isAutoSuggestVisible === true ? (
                                    <div
                                      className={
                                        this.props.cssfile
                                          .activity_autocompContainer
                                      }
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    >
                                      <div
                                        className={
                                          this.props.cssfile
                                            .input_search_destination
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      >

                                        <input
                                          type="text"
                                          tabIndex={1}
                                          autoFocus
                                          autoComplete={"off"}
                                          id="myTextField"
                                          placeholder={`Search by Destinations / Cities / Activities`}
                                          maxLength={24}
                                          className={
                                            this.props.cssfile
                                              .search_widget_input_new
                                          }
                                          value={
                                            !cf.isValueEmpty(
                                              this.state.activityName
                                            )
                                              ? this.state.activityName
                                              : ""
                                          }
                                          onChange={(event) => {
                                            event.stopPropagation();
                                            this.onChanegeSetActivityName(
                                              event.target.value
                                            );
                                            // console.log("event.target.value2", event.target.value);
                                          }}
                                          onClick={(e) => {
                                            this.scrollToMyRef();
                                            e.stopPropagation();
                                            this.setState((prevState) => {
                                              return {
                                                ...prevState,
                                                isAutoSuggestVisible: true,
                                                isError: "",
                                                // activityName: '',
                                              };
                                            });
                                          }}
                                          onKeyDown={(e) => {
                                            e.stopPropagation();
                                            this.keyPress(e.key);
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={
                                          this.props.cssfile.activity_autocompWrap
                                        }
                                      >


                                        <div
                                          className={
                                            this.props.cssfile
                                              .activity_autocomplete_value
                                          }
                                          id="ACTIVITY-AUTO-SUGGEST-DATA-LIST"
                                        >
                                          {this.state.recentSearchData.length > 0 && (
                                            <>
                                              <div className={this.props.cssfile.recent_search_header}>
                                                <div
                                                  className={
                                                    this.props.cssfile
                                                      .activity_suggestionLblrecent
                                                  }
                                                >
                                                  Recent Searches
                                                </div>
                                                <button
                                                  className={
                                                    this.props.cssfile
                                                      .clearbtn
                                                  }
                                                  onClick={() => this.clearRecentSearch()}
                                                >Clear</button>
                                              </div>
                                              {this.state.recentSearchData.map(
                                                (ele) => {
                                                  return (
                                                    <div
                                                      className={
                                                        this.props.cssfile
                                                          .activity_autocomplete_element
                                                      }
                                                    >

                                                      <div className={this.props.cssfile.activity_autocomplete_location_wrap}>
                                                        <div
                                                          className={
                                                            this.props.cssfile
                                                              .activity_autocompIcon
                                                          }
                                                        >
                                                          <img src={`/images/${ele?.destination_type == 2 ? "experiences_city.svg" : "location-grey.svg"}`} alt="locationicon" />
                                                        </div>
                                                        <div
                                                          className={
                                                            this.props.cssfile
                                                              .activity_autocomplete_name
                                                          }
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.setState({
                                                              activityName:
                                                                ele?.city,
                                                              isAutoSuggestVisible:
                                                                false,
                                                            });
                                                            this.onClickSetActivityName(
                                                              ele
                                                            );
                                                          }}
                                                        >
                                                          {ele?.title || ele?.city}
                                                        </div>
                                                        {/* <div className={this.props.cssfile.activity_autonwLabel}>United Arab Emirates</div> */}
                                                      </div>
                                                      <div
                                                        className={
                                                          this.props.cssfile
                                                            .activity_autocompIcon_arrow
                                                        }
                                                      >
                                                        <img src="/images/arrow-right-golden.svg" alt="locationicon" />
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </>
                                          )}
                                          {!cf.isValueEmpty(this.state.autoSuggestCityData) &&
                                            this.state.autoSuggestCityData.length > 0 ? (
                                            <>
                                              {this.state.autoSuggestCityData.length > 0 ? <div
                                                className={
                                                  this.props.cssfile
                                                    .activity_suggestionLbl
                                                }
                                              >
                                                Popular Searches
                                              </div> : null}

                                              {this.state.autoSuggestCityData.map((element, index) => (
                                                <div
                                                  key={`city-${index}`}
                                                  className={this.props.cssfile.activity_autocomplete_element}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.setState({
                                                      activityName: element.city,
                                                      isAutoSuggestVisible: false,
                                                      destinationDropdown: false,
                                                    });
                                                    this.onClickSetActivityName(element);
                                                  }}
                                                >
                                                  <div className={this.props.cssfile.activity_autocomplete_location_wrap}>
                                                    <div className={this.props.cssfile.activity_autocompIcon}>
                                                      <img
                                                        src={`/images/${element?.destination_type == 2
                                                          ? "experiences_city.svg"
                                                          : "location-grey.svg"
                                                          }`}
                                                        alt="locationicon"
                                                      />
                                                    </div>

                                                    <div className={this.props.cssfile.activity_autocomplete_name}>
                                                      {element.title || element.city}
                                                    </div>
                                                  </div>

                                                  <div className={this.props.cssfile.activity_autocompIcon_arrow}>
                                                    <img src="/images/arrow-right-golden.svg" alt="arrow" />
                                                  </div>
                                                </div>
                                              ))}
                                            </>
                                          ) : (
                                            <div className={this.props.cssfile.empty_state}>
                                              <div className={this.props.cssfile.empty_state__icon}>
                                                <img src="/images/search_noresult.svg" alt="No Result" />
                                              </div>
                                              <p className={this.props.cssfile.empty_state__text}>
                                                Oops! no results found.
                                              </p>
                                              <p className={this.props.cssfile.empty_state__subtext}>
                                                We didn’t find anything. Try adjusting your search
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>

                              </div>
                            </div>

                            {/* <div
                    className={`${this.props.cssfile.activity_search_details_row} ${this.props.cssfile.activity_nw}`}
                  > */}
                            <div
                              className={window.location.pathname === "/" || window.location.pathname === "/activities" ? this.props.cssfile.activity_search_class : this.props.cssfile.activity_search_class_other}
                            >                              <button
                              tabIndex={3}
                              className={
                                this.props.isSrp
                                  ? this.state?.btnClicked
                                    ? `${this.props.cssfile.srp_search_widget_btn} ${this.props.cssfile.search_button} loading`
                                    : this.props.cssfile.srp_search_widget_btn
                                  : this.state?.btnClicked
                                    ? `${this.props.cssfile.activity_search_widget_btn} ${this.props.cssfile.search_button} loading`
                                    : this.props.cssfile.search_button
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                this.onClickSearchActivity();
                              }}
                            >
                                <div className={this.props.cssfile.search_button_imgbox}>
                                  <img className={this.props.cssfile.search_button_img} src="/images/search-golden.svg" alt="search" />
                                </div>
                              </button>
                            </div>
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state?.isError == "emptyString" ? <div className={this.props.cssfile.error_message}>Please enter a destination, city or activity</div> : this.state?.isError == "NoMatch" ? <div className={this.props.cssfile.error_message}>Please enter a valid destination</div> : null}
                </div>

              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}